import { Link } from "react-router-dom";

const features = [
  {
    icon: "ri-file-list-3-line",
    title: "资料整理完整",
    desc: "每部影视都附带导演、主演、地区、年份与剧情简介，挑片前先看清楚。",
  },
  {
    icon: "ri-filter-3-line",
    title: "筛选与搜索",
    desc: "按地区、年份、类型组合筛选，也可以直接用关键词搜索影视与应用。",
  },
  {
    icon: "ri-smartphone-line",
    title: "工具一并推荐",
    desc: "影视详情页直接给出适配的看片应用，减少在多个平台之间来回跳转。",
  },
];

const stats = [
  { value: "38", label: "精选影视条目" },
  { value: "8", label: "看片应用收录" },
  { value: "3", label: "内容分类栏目" },
  { value: "20", label: "每页展示条数" },
];

export default function SiteIntro() {
  return (
    <section className="w-full mt-16 md:mt-24 bg-primary-950">
      <div className="w-full max-w-page mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <span className="text-[11px] tracking-[0.22em] text-accent-400 font-label uppercase">About the site</span>
            <h2 className="mt-3 text-2xl md:text-3xl font-bold text-background-50 leading-snug">
              为普通影迷准备的
              <br />
              影视资料与应用指南
            </h2>
            <p className="mt-4 text-sm leading-7 text-primary-200">
              看片免费app网站不提供片源存储，我们做的是整理：把散落在各处的影视资料、评分、简介与适配的看片工具整理到同一处，
              让你少花时间找，多花时间看。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-accent-500 text-primary-950 text-sm whitespace-nowrap hover:bg-accent-400 transition-colors"
              >
                了解网站定位
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/search"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-primary-700 text-primary-100 text-sm whitespace-nowrap hover:border-accent-400 hover:text-accent-300 transition-colors"
              >
                搜索影视资源
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
              {features.map((feature) => (
                <div
                  key={feature.title}
                  className="rounded-lg border border-primary-800 bg-primary-900/60 p-4 md:p-5"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-800 text-accent-400">
                    <i className={`${feature.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-semibold text-background-50">{feature.title}</h3>
                  <p className="mt-1.5 text-xs leading-6 text-primary-300">{feature.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
              {stats.map((stat) => (
                <div key={stat.label} className="rounded-lg bg-primary-900/40 border border-primary-800/80 px-4 py-3">
                  <p className="text-xl md:text-2xl font-bold text-accent-400 font-label">{stat.value}</p>
                  <p className="mt-0.5 text-[11px] text-primary-300">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}